import {
  CartItemTypes,
  ICartItemType,
  ICartItem_Product,
  ICartItem_Slot,
  ICartManageItemParams_Event,
  ICartManageItemParams_Product,
  ICartManageItemParams_Slot,
} from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import { ProductPreviewTypes } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { ITimeSlotDetails } from "@/api/AppApi/services/time-slots/interfaces/api-time-slots-interfces";

export const getItemCartPropsToPost_product = (
  cartItem: ICartItem_Product,
): ICartManageItemParams_Product => {
  // if (!cartItem) return null;
  return {
    type: CartItemTypes.product,
    cartId: cartItem?.id,
    id: cartItem?.inner_id,
    quantity: cartItem?.quantity,
    note: cartItem?.note,
    addons: cartItem.addons.map((addOn) => ({
      id: addOn?.id,
      quantity: addOn?.quantity,
    })),
    attrs_values: cartItem.others.attrs_values.map((attr) => attr.id),
    other_inputs: { ...cartItem?.others?.data_fields },
    bundle_items: (cartItem as ICartItem_Product)?.bundle_items,
  };
};
export const getItemCartPropsToPost_slot = (
  cartItem: ICartItem_Slot,
): ICartManageItemParams_Slot | undefined => {
  if (!cartItem) return;
  return {
    type: CartItemTypes.slot,
    cartId: cartItem?.id,
    id: cartItem?.inner_id,
    quantity: cartItem?.quantity,
    note: cartItem?.note,
    date: cartItem?.others.date,
    other_inputs: cartItem?.others?.data_fields,
    product_id: cartItem?.inner_id,
  };
};

export const getById_ItemPropsToPost_Product_Event = (
  cartItems: ICartItemType[],
  id: number,
  type: ProductPreviewTypes,
  cartItemID?: number,
): ICartManageItemParams_Product | ICartManageItemParams_Event => {
  const ProductAsCartItemType = fromProductPreviewTypeToCartItemType(
    type,
  ) as unknown as CartItemTypes.event | CartItemTypes.product;
  const index = (cartItems ?? []).findIndex(
    (cartItem) =>
      cartItem.type === ProductAsCartItemType &&
      cartItem.inner_id === id &&
      cartItem.id === cartItemID,
  );
  const cartItem = index < 0 ? null : cartItems[index];
  return {
    type: ProductAsCartItemType,
    cartId: cartItem?.id,
    id: id,
    quantity: cartItem?.quantity ?? 0,
    note: cartItem?.note ?? "",
    addons:
      cartItem?.addons?.map((addOn) => ({
        id: addOn?.id,
        quantity: addOn?.quantity,
      })) ?? [],
    attrs_values:
      (cartItem as ICartItem_Product)?.others.attrs_values.map(
        (attr) => attr.id,
      ) ?? [],
    other_inputs: { ...cartItem?.others?.data_fields },
    bundle_items: (cartItem as ICartItem_Product)?.bundle_items,
  };
};
export const getById_ItemPropsToPost_slot = (
  cartItems: ICartItemType[],
  id: number,
): ICartManageItemParams_Slot => {
  const index = (cartItems ?? []).findIndex(
    (cartItem) =>
      cartItem.type === CartItemTypes.slot && cartItem.inner_id === id,
  );
  const cartItem = index < 0 ? null : (cartItems[index] as ICartItem_Slot);
  return {
    type: CartItemTypes.slot,
    cartId: cartItem?.id,
    id: id,
    quantity: cartItem?.quantity ?? 0,
    note: cartItem?.note ?? "",
    date: (cartItem as ICartItem_Slot).others?.date ?? "",
    other_inputs: (cartItem as ICartItem_Slot).others?.data_fields ?? {},
    product_id: cartItem?.inner_id!,
  };
};
export const countFromCart = (
  cartItems: ICartItemType[],

  id: number,
  isConfigurable: boolean = false,
  cartItemID?: number,
) => {
  if (!cartItems || cartItems.length === 0) return 0;

  const index = cartItems.findIndex(
    (item) => item.inner_id === id && cartItemID === item.id,
  );

  if (isConfigurable) {
    const configrubleProductChilds = cartItems.filter(
      (item) => (item as ICartItem_Product).others.parent_id === id,
    );

    return configrubleProductChilds.length || cartItems[index]?.quantity || 0;
  }

  return index < 0 ? 0 : cartItems[index].quantity;
};
export const isSlotInCart = (
  cartItems: ICartItemType[],
  slot: ITimeSlotDetails,
) => {
  if (!cartItems || cartItems.length === 0) return false;
  const filteredItems = cartItems.filter(
    (cartItem) => cartItem.type === CartItemTypes.slot,
  );
  const index = (filteredItems as ICartItem_Slot[]).findIndex(
    (cartItem) =>
      cartItem.inner_id === slot.id && cartItem.others.date === slot.date,
  );
  return index >= 0;
};
export const getCartId = (
  cartItems: ICartItemType[],

  id: number | null,
  cartItemID?: number,
) => {
  if (!cartItems || cartItems.length === 0) return null;

  const index = cartItems.findIndex(
    (cartItem) => cartItem.inner_id === id && cartItemID === cartItem.id,
  );
  return index < 0 ? null : cartItems[index].id;
};

export function debounce(cb: any, delay = 300) {
  let timeout: NodeJS.Timeout | null;

  return (...args: any) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      cb(...args);
    }, delay);
  };
}

export const fromProductPreviewTypeToCartItemType = (
  type: ProductPreviewTypes,
) => {
  switch (type) {
    case ProductPreviewTypes.appointment:
      return CartItemTypes.slot;
    case ProductPreviewTypes.consultation:
      return CartItemTypes.consultation;
    case ProductPreviewTypes.event:
      return CartItemTypes.event;
    case ProductPreviewTypes.general:
    default:
      return CartItemTypes.product;
  }
};
